import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

import { Box } from '@mui/material';

import IRHeader from '@/components/Headers/IRHeader';

export default function IRLayout({ children }) {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src =
      '//tools.euroland.com/tools/common/eurolandiframeautoheight/eurolandtoolsintegrationobject.js';
    document.getElementsByTagName('head')[0].appendChild(script);

    script.onload = function () {
      setIsLoaded(true);
    };
  }, []);

  return (
    <>
      <IRHeader />
      <ContextProvider isScriptLoaded={isLoaded}>
        <Box marginTop={{ md: '93px' }}>{children}</Box>
      </ContextProvider>
    </>
  );
}

const Context = createContext();

const ContextProvider = ({ isScriptLoaded, children }) => {
  const value = useMemo(
    () => ({
      isScriptLoaded,
    }),
    [isScriptLoaded],
  );

  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const useIRContext = () => useContext(Context);
